import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Leaf } from "lucide-react";

const links = [
    { to: "/", label: "Início" },
    { to: "/cabanas", label: "Cabanas" },
    { to: "/reservas", label: "Reservas" },
    { to: "/faq", label: "FAQ" },
    { to: "/contato", label: "Contato" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header
            data-testid="navbar"
            className="sticky top-0 z-50 backdrop-blur-xl bg-cdb-cream/85 border-b border-cdb-sand"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4 flex items-center justify-between">
                <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2 group">
                    <span className="w-10 h-10 rounded-full bg-cdb-forest flex items-center justify-center group-hover:bg-cdb-forestDark transition-colors">
                        <Leaf className="w-5 h-5 text-cdb-cream" />
                    </span>
                    <span className="text-lg sm:text-xl font-bold text-cdb-forest tracking-tight">
                        Cabanas da Barra
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-1">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
                            className={({ isActive }) =>
                                `px-4 py-2 rounded-full text-sm font-bold transition-all ${
                                    isActive
                                        ? "bg-cdb-forest text-cdb-cream"
                                        : "text-cdb-earth hover:bg-cdb-sand"
                                }`
                            }
                            end
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <Link
                    to="/reservas"
                    data-testid="navbar-cta-reservar"
                    className="hidden md:inline-flex items-center justify-center bg-cdb-gold hover:bg-cdb-goldDark text-white rounded-full px-5 py-2.5 text-sm font-bold transition-all shadow-sm hover:shadow-md"
                >
                    Reservar agora
                </Link>

                <button
                    data-testid="navbar-mobile-toggle"
                    className="md:hidden p-2 rounded-full hover:bg-cdb-sand text-cdb-forest"
                    onClick={() => setOpen((s) => !s)}
                    aria-label="Abrir menu"
                >
                    {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-cdb-sand bg-cdb-cream px-6 py-4 space-y-2">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            onClick={() => setOpen(false)}
                            data-testid={`nav-link-mobile-${l.to.replace("/", "") || "home"}`}
                            className={({ isActive }) =>
                                `block px-4 py-3 rounded-xl text-base font-bold transition-all ${
                                    isActive
                                        ? "bg-cdb-forest text-cdb-cream"
                                        : "text-cdb-earth hover:bg-cdb-sand"
                                }`
                            }
                            end
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/reservas"
                        onClick={() => setOpen(false)}
                        data-testid="navbar-mobile-cta-reservar"
                        className="block text-center bg-cdb-gold hover:bg-cdb-goldDark text-white rounded-full px-5 py-3 font-bold"
                    >
                        Reservar agora
                    </Link>
                </div>
            )}
        </header>
    );
}
